import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmWithReasonForm";
import {cancelCancelSalesOrder} from "../../actions/SalesApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class CancelSalesOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("orderId", this.props.id)
    return this.props.cancelSalesOrder(updatedValues.toJS())
      .then((response) => {
        if (response.data.cancelSalesOrder.errors.length <= 0) {
          this.props.cancelCancelSalesOrder();
        } else {
          let errors = createValidationErrors(response.data.cancelSalesOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCancelSalesOrder();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}>
        <p>Cancelling a sales order will void the invoice and cancel any shipments. If this is a subscription, then the subscription will be put on pause.</p>
      </Form>
    )
  }
}

const CANCEL_SALES_ORDER = gql`
  mutation cancelSalesOrder($data: CancelSalesOrderInput!) {
    cancelSalesOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CANCEL_SALES_ORDER, {
    props: ({ mutate }) => ({
      cancelSalesOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelCancelSalesOrder})(withMutation(CancelSalesOrderFormContainer));